import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import React from "react";

const facts = [
  {
    emoji: "📜",
    title: "Longest Constitution",
    fact: "India has the longest written constitution in the world — 448 articles across 25 parts."
  },
  {
    emoji: "🎓",
    title: "Ambedkar’s Legacy",
    fact: "Dr. B.R. Ambedkar earned doctorates from Columbia and the London School of Economics."
  },
  {
    emoji: "🚀",
    title: "Space Pride",
    fact: "ISRO’s Mangalyaan was the world’s cheapest Mars mission — under ₹500 crore."
  },
  {
    emoji: "🌾",
    title: "Agriculture Giant",
    fact: "India ranks 2nd globally in farm output. Yet rural areas still face basic issues."
  },
  {
    emoji: "👩‍⚕️",
    title: "Women’s Role",
    fact: "India had a woman Prime Minister before the US had one."
  }
];

const DidYouKnowCarousel = () => {
  const scrollRef = React.useRef();

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -300 : 300,
        behavior: "smooth"
      });
    }
  };

  return (
    <div className="relative bg-orange-50 py-10 px-4 mt-12 border-t border-orange-200">
      <h2 className="text-2xl md:text-3xl font-bold text-orange-700 mb-6 text-center">
        🧠 Did You Know? — भारत से जुड़ी गौरवशाली बातें
      </h2>

      <div className="relative">
        <button
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 p-2 bg-white border rounded-full shadow hover:bg-orange-100"
          onClick={() => scroll("left")}
        >
          <ChevronLeft size={20} />
        </button>

        <div
          ref={scrollRef}
          className="flex overflow-x-auto space-x-6 px-10 py-4 scrollbar-hide"
        >
          {facts.map((item, idx) => (
            <motion.div
              key={idx}
              whileHover={{ scale: 1.05 }}
              className="min-w-[260px] bg-white border border-orange-100 shadow-md rounded-xl p-4 flex-shrink-0"
            >
              <div className="text-3xl mb-2">{item.emoji}</div>
              <h3 className="text-lg font-semibold text-orange-700 mb-1">
                {item.title}
              </h3>
              <p className="text-sm text-gray-700">{item.fact}</p>
            </motion.div>
          ))}
        </div>

        <button
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 p-2 bg-white border rounded-full shadow hover:bg-orange-100"
          onClick={() => scroll("right")}
        >
          <ChevronRight size={20} />
        </button>
      </div>
    </div>
  );
};

export default DidYouKnowCarousel;
